import { Injectable } from '@angular/core';
import { createStore } from '@ngneat/elf';
import { addEntities, withEntities } from '@ngneat/elf-entities';
import { localStorageStrategy, persistState } from '@ngneat/elf-persist-state';
import { ClientService } from '../services/client.service';

const logsStore = createStore({ name: 'logs' }, withEntities<any>());

export const persist = persistState(logsStore, {
  key: 'logs',
  storage: localStorageStrategy,
});

@Injectable({ providedIn: 'root' })
export class LogsRepository {
  constructor(private clientService: ClientService) {}

  public async insertLog(log: any) {
    logsStore.update(addEntities([log]));
  }
}
